var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import Vue from 'vue';
var GOOGLE_ANALYTICS_MESURE_ID = process.env.VUE_APP_GOOGLE_ANALYTICS_MESURE_ID;
var GoogleAnalyticsModule = (function (_super) {
    __extends(GoogleAnalyticsModule, _super);
    function GoogleAnalyticsModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gaTagScript = null;
        _this.gaTagScript2 = null;
        return _this;
    }
    GoogleAnalyticsModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.prototype.$sendGAEvent = _this.sendGAEvent;
            resolve(true);
        });
    };
    GoogleAnalyticsModule.prototype.finalizeInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.addGATag();
            resolve(true);
        });
    };
    GoogleAnalyticsModule.prototype.addGATag = function () {
        if (this.gaTagScript !== null)
            return;
        console.log('addGATag', GOOGLE_ANALYTICS_MESURE_ID);
        var body = document.body;
        this.gaTagScript = document.createElement('script');
        this.gaTagScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + GOOGLE_ANALYTICS_MESURE_ID);
        body.appendChild(this.gaTagScript);
        var inlineScript = document.createTextNode('window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag(\'js\', new Date()); gtag(\'config\', \'' + GOOGLE_ANALYTICS_MESURE_ID + '\'); console.log(\'ga enabled\');');
        this.gaTagScript2 = document.createElement('script');
        this.gaTagScript2.setAttribute('type', 'text/javascript');
        this.gaTagScript2.appendChild(inlineScript);
        body.appendChild(this.gaTagScript2);
    };
    GoogleAnalyticsModule.prototype.removeGATag = function () {
        if (this.gaTagScript === null || this.gaTagScript2 === null)
            return;
        var body = document.body;
        body.removeChild(this.gaTagScript);
        body.removeChild(this.gaTagScript2);
        this.gaTagScript = null;
        this.gaTagScript2 = null;
    };
    GoogleAnalyticsModule.prototype.sendGAEvent = function (eventName, data, callback) {
        console.log('sendGAEvent', eventName, data, this.gaTagScript, this.gaTagScript2);
        if (!this.gaTagScript || !this.gaTagScript2) {
            if (callback)
                callback(false);
            return;
        }
        console.log('sending event...');
        if (!data)
            data = {};
        data['event_callback'] = function () {
            if (callback)
                callback(true);
        };
        try {
            gtag('event', eventName, data);
        }
        catch (exception) {
            if (callback)
                callback(false);
        }
    };
    return GoogleAnalyticsModule;
}(BaseModule));
export default GoogleAnalyticsModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/google-analytics/index.ts
// module id = null
// module chunks = 